export const accountReducerKey = 'accountReducerKey';
export const accountSetIsLoadingReducerType = 'accountSetIsLoadingReducerType';
export const accountSetUsernameReducerType = 'accountSetUsernameReducerType';
export const accountSetEmailReducerType = 'accountSetEmailReducerType';
// eslint-disable-next-line sonarjs/no-hardcoded-passwords
export const accountSetPasswordDataReducerType = 'accountSetPasswordDataReducerType';
export const accountSetRestrictedWordsReducerType = 'accountSetRestrictedWordsReducerType';
export const typeOfAccountErrorModal = 'typeOfAccountErrorModal';
